import {
  Component,
  OnChanges,
  forwardRef,
  AfterViewInit,
  ChangeDetectionStrategy
} from '@angular/core'

import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms'

import { DropdownComponent } from '../dropdown/dropdown.component'

export const VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MultipleSelectDropdownComponent),
  multi: true,
}

@Component({
  selector: 'multiple-select-dropdown',
  host: {
    class: 'ui multiple selection search dropdown'
  },
  styleUrls: ['multiple-select-dropdown.component.less'],
  templateUrl: 'multiple-select-dropdown.component.html',
  providers: [
    VALUE_ACCESSOR
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultipleSelectDropdownComponent extends DropdownComponent {
  settingValues: number

  fireOnChange(values) {
    if (this.onChange && !this.settingValues) {
      let indexes = []
      let choices = []
      if (values !== '') {
        indexes = values.split(',').map(Number)
      }
      const length = indexes.length
      for (let i = 0; i < length; i +=1) {
        const index = indexes[i]
        if (this.options[index]) {
          choices.push(this.options[index])
        } else if (this.dropdownSettings.allowAdditions) {
          choices = this.createNewDropdownValue(values.split(',')[i], choices)
        }
      }
      this.onChange(choices)
      this.modelChange.emit(choices)
    } else {
      this.settingValues -= 1
    }
  }

  createNewDropdownValue(value, choices) {
    let newDropdownValue = {}
    for (let key of Object.values(this.dropdownSettings.fields) as string[]) {
      newDropdownValue[key] = value
    }
    choices.push(newDropdownValue)
    choices = choices.unique()

    return choices
  }

  setSelected(modelValues) {
    let itemValues = []
    for (let modelValue of modelValues) {
      let dropdownValue = Object.get(modelValue, this.dropdownSettings['fields']['value'])
      if (this.items) {
        const index = this.options.findIndex(o => {
          return (
            o === modelValue ||
            Object.isEqual(o, modelValue) ||
            (this.getValue(o) != null && this.getValue(o) === dropdownValue)
          )
        })
        const item = this.items[index]
        if (item == null) { throw new Error(`${JSON.stringify(modelValue)} is not a valid dropdown value`) }

        itemValues.push(item.value)
      }
    }
    setTimeout(() => {
      this.$element.dropdown('set exactly', itemValues)
      this.defaultSelected = null
    })
    this.settingValues = itemValues.length
  }
}
